import { useCallback, useEffect, useState } from "react";
import { apiRequest } from "src/async/apiUtils";
import PaginationFooter from "src/components/Shared/PaginationFooter";
import Table from "src/components/Shared/Table/Table";
import TRHeader from "src/components/Shared/Table/TRHeader";
import TableOptions from "src/components/Shared/TableOptions";
import SelectMenu from "src/components/Shared/Forms/Selects/SelectMenu";
import { H3 } from "src/components/Shared/Text/Headers";
import CrashIncidentEntry from "src/components/ServerMonitoring/CrashIncidentEntry";

const statusOptions = [
  { key: "All statuses", value: "" },
  { key: "Crashed", value: "crashed" },
  { key: "Recovered", value: "recovered" },
];

const headerClass = "px-4 py-3.5 text-left text-sm font-semibold text-gray-900 sm:pl-6";

const CrashHistoryList = ({ refreshKey = 0, onView }) => {
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [statusFilter, setStatusFilter] = useState("");
  const [incidents, setIncidents] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const loadIncidents = useCallback(async () => {
    try {
      setLoaded(false);
      const res = await apiRequest("get", `/server-monitor/incidents`, { queries: { limit, offset, status: statusFilter || null } });
      if (res.data.status === 200) {
        setIncidents(res.data.data || []);
        setMeta(res.data.meta);
      } else {
        setIncidents([]);
        setMeta(null);
      }
    } catch (error) {
    } finally {
      setLoaded(true);
    }
  }, [limit, offset, statusFilter]);

  useEffect(() => {
    loadIncidents();
  }, [loadIncidents, refreshKey]);

  return (
    <div className="mt-8">
      <H3 caption="SaaS Portal container crashes and runtime restarts detected from DigitalOcean. Normal deployments are excluded. Crashes are kept for 7 days.">Crash History</H3>
      <TableOptions
        leftContent={
          <SelectMenu
            inline
            label="Status"
            options={statusOptions}
            startIndex={Math.max(
              statusOptions.findIndex((option) => option.value === statusFilter),
              0,
            )}
            setOption={(option) => {
              setOffset(0);
              setStatusFilter(option.value);
            }}
          />
        }
      />
      <Table
        tableHeader={
          <TRHeader>
            <th className={`${headerClass} rounded-tl-lg`}>Crash Time</th>
            <th className={`${headerClass} hidden md:table-cell`}>Recovery Time</th>
            <th className={`${headerClass} hidden md:table-cell`}>Downtime</th>
            <th className={headerClass}>Reason</th>
            <th className={`${headerClass} hidden lg:table-cell`}>Confidence</th>
            <th className={`${headerClass} hidden lg:table-cell`}>Memory</th>
            <th className={headerClass}>Status</th>
            <th className={`${headerClass} rounded-tr-lg`}>
              <span className="sr-only">Action</span>
            </th>
          </TRHeader>
        }
        colSpan="8"
        loaded={loaded}
        dataExists={incidents?.length > 0}>
        {incidents?.map((incident) => (
          <CrashIncidentEntry
            key={incident._id}
            incident={incident}
            onView={onView}
          />
        ))}
      </Table>
      <PaginationFooter
        itemName="Crash record"
        limit={limit}
        offset={offset}
        count={meta?.count}
        onChange={({ limit, offset }) => {
          setLimit(limit);
          setOffset(offset);
        }}
      />
    </div>
  );
};

export default CrashHistoryList;
